import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import HeroText from "../assets/herotext.png";
import HeroImage from "../assets/hero.png";
import HeroImageSecond from "../assets/how-it-works-scaled.png";
import FooterImage from "../assets/imageFooter.png";

import Apple from "../assets/apple-store.svg";
import Huawei from "../assets/huawei-store-badge.svg";
import Google from "../assets/googleplay.svg";
import image1 from "../assets/1.png";
import image2 from "../assets/2.png";
import image3 from "../assets/3.png";
import image4 from "../assets/4.png";

import chat from "../assets/icons8-chat-32.png";
import axios from "axios";

import { MobiSignin, getCountryCode } from "../Firebase";
import LanguageSwitcher from "../components/LanguageSwitcher";
import countriesData from "../countries.json";

function LandingPage() {
  const navigate = useNavigate();
  const [selectedImage, setSelectedImage] = useState(image1);
  const [loading, setLoading] = useState(false);
  const [ResetModal, setOpenReset] = useState(false);
  const [ResetLoader, setResetLoader] = useState(false);
  const [ResetPhone, setResetPhone] = useState("");
  const [ResetMessage, setResetmessage] = useState("");

  const [Phonenumber, setPhonenumber] = useState("");
  const [Password, setPassword] = useState("");
  const [Country, setCountry] = useState("");
  const [SigninError, setSigninError] = useState("");
  const { t } = useTranslation();

  // Function to get country code prefix based on country from countries.json
  const getCountryCodePrefix = (countryCode) => {
    if (!countryCode) return '';
    
    const normalizedCode = countryCode.trim().toUpperCase();
    const country = countriesData.find(
      (c) => c.code === normalizedCode
    );
    
    return country?.dial_code || '';
  };

  async function subscribe() {
    setLoading(true);

    try {
      const country = await getCountryCode();
      window.location.href = `https://publisherads.click/?SMCampaign=f3aeaff8-ae65-4723-8c12-4fbb76bb72ed&ClickID=YOUR_CLICK_ID&Pub_ID=YOUR_PUB_ID&Aff_ID=YOUR_AFF_ID&extra=YOUR_Dynamic_Parameter_IF_Needed&extra1=YOUR_Dynamic_Parameter_IF_Needed&utm_source=affiliate&utm_medium=cpc&utm_campaign={campaignid}&utm_content={adgroupid}&utm_term={keyword}&country=${country}&themeid=3&portal=AiAvatar`;
    } catch (error) {
      console.error("Error fetching country:", error);
    } finally {
      setLoading(false);
    }
  }

  const handleImageChange = (step) => {
    const images = {
      1: image1,
      2: image2,
      3: image3,
      4: image4,
    };
    setSelectedImage(images[step]);
  };

  const redirectToStore = (platform) => {
    const urls = {
      ios: "https://apps.apple.com/app/id1668151298",
      android:
        "https://play.google.com/store/apps/details?id=avatar.ai.creator",
      huawei: "https://appgallery.huawei.com/#/app/C109045405",
    };

    if (urls[platform]) {
      window.open(urls[platform], "_blank"); // Opens in a new tab
    }
  };

  function OpenResetModal() {
    setOpenReset(true);
  }

  function CloseResetModal() {
    setOpenReset(false);
  }

  function resetpass(phone) {
    setResetLoader(true);
    fetch(
      `http://apiv2.mobileartsme.com/resetpass?phonenumber=${phone}&IDService=2`
    )
      .then((res) => res.json())
      .then((response) => {
        setResetLoader(false);
        setResetmessage(response.result);
      });
  }

  async function Signin() {
    setLoading(true);

    const phoneToSend = Phonenumber.replace(/\s/g, "");

    const response = await MobiSignin(phoneToSend, Password, Country);

    if (response.Error != 0) {
      setSigninError(response.Result);
    } else {
      if (response.Result.Status != 0) {
        setSigninError(response.Result.Description);
      }
    }
    setLoading(false);
  }

  useEffect(() => {
    getCountryCode()
      .then((countryText) => {
        console.log("Country:", countryText);
        setCountry(countryText);

        // Prefill phone number with country code if input is empty (language/geo handled in i18n/config.js via same API)
        const countryPrefix = getCountryCodePrefix(countryText);
        if (countryPrefix) {
          setPhonenumber((currentPhone) => {
            if (!currentPhone || currentPhone.trim() === '') {
              return countryPrefix;
            }
            return currentPhone;
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching country:", error);
      });
  }, []);

  return (
    <div style={{ background: "black" }}>
      <section>
        <div>
          <div className="row" style={{ width: "100%" }}>
            <div
              data-aos="fade-down"
              className="heroLeft py-7 col-lg-7 d-flex flex-column justify-content-center"
            >
              <div>
                <p style={{ fontSize: "2rem" }} translate="no">
                  {t('landing.title')}
                </p>
                <img src={HeroText} />
                <p className="py-2">
                  {t('landing.subtitle')}
                </p>

                {/* <div className="mb-5 d-flex flex-row gap-3">
                  <a href="#download_Section"

                                        className="lp-btn download-button">Download Now
                                        <svg aria-hidden="true" className="e-font-icon-svg e-fas-download" fill="white" height={'18px'} viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"></path></svg>
                                    </a>

                  <button
                                        onClick={() => subscribe()}
                                        className="lp-btn subscribe-button" >

                                        Subscribe
                                        <svg aria-hidden="true" className="e-font-icon-svg e-fab-cc-visa"
                                            width={'18px'} fill="white"
                                            viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg"><path d="M470.1 231.3s7.6 37.2 9.3 45H446c3.3-8.9 16-43.5 16-43.5-.2.3 3.3-9.1 5.3-14.9l2.8 13.4zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM152.5 331.2L215.7 176h-42.5l-39.3 106-4.3-21.5-14-71.4c-2.3-9.9-9.4-12.7-18.2-13.1H32.7l-.7 3.1c15.8 4 29.9 9.8 42.2 17.1l35.8 135h42.5zm94.4.2L272.1 176h-40.2l-25.1 155.4h40.1zm139.9-50.8c.2-17.7-10.6-31.2-33.7-42.3-14.1-7.1-22.7-11.9-22.7-19.2.2-6.6 7.3-13.4 23.1-13.4 13.1-.3 22.7 2.8 29.9 5.9l3.6 1.7 5.5-33.6c-7.9-3.1-20.5-6.6-36-6.6-39.7 0-67.6 21.2-67.8 51.4-.3 22.3 20 34.7 35.2 42.2 15.5 7.6 20.8 12.6 20.8 19.3-.2 10.4-12.6 15.2-24.1 15.2-16 0-24.6-2.5-37.7-8.3l-5.3-2.5-5.6 34.9c9.4 4.3 26.8 8.1 44.8 8.3 42.2.1 69.7-20.8 70-53zM528 331.4L495.6 176h-31.1c-9.6 0-16.9 2.8-21 12.9l-59.7 142.5H426s6.9-19.2 8.4-23.3H486c1.2 5.5 4.8 23.3 4.8 23.3H528z"></path></svg>
                                    </button>
                </div> */}
                <a
                  className="d-flex flex-row gap-3 align-items-center"
                  style={{ color: "white", cursor: "pointer" }}
                  href="#signinsection"
                >
                  <span>
                    {t('landing.clickToSignin')}{" "}
                    <span style={{ color: "#FED501", fontWeight: "700" }}>
                      {t('landing.signin')}
                    </span>
                  </span>
                  <svg
                    aria-hidden="true"
                    className="e-font-icon-svg e-fas-sign-in-alt"
                    viewBox="0 0 512 512"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="white"
                    height={"15px"}
                  >
                    <path d="M416 448h-84c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h84c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32h-84c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12h84c53 0 96 43 96 96v192c0 53-43 96-96 96zm-47-201L201 79c-15-15-41-4.5-41 17v96H24c-13.3 0-24 10.7-24 24v96c0 13.3 10.7 24 24 24h136v96c0 21.5 26 32 41 17l168-168c9.3-9.4 9.3-24.6 0-34z"></path>
                  </svg>
                </a>
              </div>
            </div>

            <div className="col-lg-5">
              <img
                src={HeroImage}
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            </div>
          </div>
        </div>
      </section>

      <section
        style={{
          backgroundImage: `url(${HeroImageSecond})`,
          backgroundSize: "cover",
        }}
      >
        <div className="container py-7">
          <div className="row section_2">
            <div className="how-it-works-image col-lg-6" data-aos="fade-up">
              <img
                src={selectedImage}
                alt="Step Illustration"
                style={{ height: "70%" }}
              />
            </div>

            <div
              className="col-lg-6 d-flex flex-column justify-content-center"
              data-aos="fade-up"
            >
              <h1 style={{ fontSize: "3.5rem" }}>{t('landing.howItWorks')}</h1>

              <div className="d-flex flex-column gap-4">
                {[
                  {
                    step: 1,
                    title: t('landing.step1.title'),
                    text: t('landing.step1.text'),
                  },
                  {
                    step: 2,
                    title: t('landing.step2.title'),
                    text: t('landing.step2.text'),
                  },
                  {
                    step: 3,
                    title: t('landing.step3.title'),
                    text: t('landing.step3.text'),
                  },
                  {
                    step: 4,
                    title: t('landing.step4.title'),
                    text: t('landing.step4.text'),
                  },
                ].map(({ step, title, text }) => (
                  <div className="step" key={step}>
                    <div>
                      <h1>
                        {step}. {title}
                      </h1>
                      <p>{text}</p>
                    </div>
                    <input
                      type="radio"
                      name="step"
                      onChange={() => handleImageChange(step)}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="download_Section">
        <div>
          <div className="row" style={{ width: "100%" }}>
            <div
              className="heroLeft py-7 col-lg-5 d-flex flex-column justify-content-center"
              data-aos="fade-up"
            >
              <div className="mb-5 loginForm" id="signinsection">
                <h1 className="fs-1 text-light mb-3">
                  {t('landing.signOnTitle')}
                </h1>
                <input
                  placeholder={t('landing.emailPlaceholder')}
                  value={Phonenumber}
                  onChange={(e) => setPhonenumber(e.target.value)}
                />
                <p
                  className="text-light small mb-0 mt-1"
                  style={{ fontStyle: "italic", opacity: 0.85 }}
                >
                  {t("landing.phoneCountryCodeHint")}
                </p>
                <div className="d-flex gap-2 mt-1">
                  <input
                    placeholder={t('landing.passwordPlaceholder')}
                    type="password"
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <button
                    className="lp-btn subscribe-button"
                    onClick={() => Signin()}
                  >
                    {loading ? (
                      <div className="spinner-border" role="status">
                        <span className="sr-only"></span>
                      </div>
                    ) : (
                      t('landing.signin')
                    )}
                  </button>
                </div>
                <p
                  className="pt-2 fs-4"
                  style={{ cursor: "pointer" }}
                  onClick={() => OpenResetModal()}
                >
                  {t('landing.forgotPassword')}
                </p>
                <p style={{ color: "red", fontSize: "1.5rem" }}>
                  {SigninError}
                </p>
              </div>

              <div className="footerDiv">
                {/* <h1 className="fs-2" >Create AI Generated Avatars</h1>

                                <p className="pt-2">Change your visual identity thanks to our AI avatar generator.
                                    Our easy to use avatar creator allows you to create custom avatars
                                    in minutes, with different styles to choice.</p> */}

                {/* <h3 className="pt-1 fs-2">
                  Generate now and let your creativity shine!
                </h3> */}

                {/* <div className="downloadSection pt-1 d-flex flex-row gap-3 flex-wrap">
                  <img
                    onClick={() => redirectToStore("ios")}
                    src={Apple}
                    alt="Download on the App Store"
                  />
                  <img onClick={() => redirectToStore('android')} src={Google} alt="Get it on Google Play" />
                  <img onClick={() => redirectToStore('huawei')} src={Huawei} alt="Download on Huawei AppGallery" />
                </div> */}

                <h3 className="mt-7 fs-2">{t('landing.getInTouch')}</h3>
                <h5
                  className="text-light d-flex flex-row gap-2 mt-2"
                  style={{ cursor: "pointer" }}
                  onClick={() => (window.location.href = "/Contact")}
                >
                  {t('landing.contactUs')}
                  <img style={{ width: "20px" }} src={chat} />
                </h5>

                <h3 className="mt-7 fs-2">{t('landing.language')}</h3>
                <div className="mt-2">
                  <LanguageSwitcher />
                </div>

                <h3 className="mt-7 fs-2">{t('landing.legal')}</h3>

                <p
                  className="mt-2 text-light"
                  onClick={() => navigate("/Portal/privacy")}
                  style={{ cursor: "pointer" }}
                >
                  {t('landing.privacyPolicy')}
                </p>

                <p
                  className="text-light"
                  onClick={() => navigate("/Portal/terms")}
                  style={{ cursor: "pointer" }}
                >
                  {t('landing.termsConditions')}
                </p>
                {Country.trim().toUpperCase() === "GR" && (
                  <>
                    <p
                      className="text-light"
                      onClick={() => navigate("/Portal/faq")}
                      style={{ cursor: "pointer" }}
                    >
                      {t('landing.faq')}
                    </p>
                    <p
                      className="text-light"
                      onClick={() => navigate("/Portal/contact")}
                      style={{ cursor: "pointer" }}
                    >
                      {t('landing.contact')}
                    </p>
                  </>
                )}
              </div>
            </div>
            <div className="col-lg-1"></div>
            <div className="col-lg-6">
              <img
                src={FooterImage}
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            </div>
          </div>
        </div>
      </section>

      <div
        className="modal fade"
        id="privacyModal"
        tabIndex="-1"
        aria-labelledby="privacyModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="privacyModalLabel">
                Privacy Policy
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="privacy-policy container mt-2">
                <p>
                  <strong>Effective Date: 17 Jan 2024</strong>
                </p>

                <p>
                  Thank you for choosing Avatalk AI ("we," "us," or "our"). This
                  Privacy Policy is designed to help you understand how we
                  collect, use, disclose, and safeguard your personal
                  information when you use our mobile application (the "App").
                </p>
                <p>
                  By downloading, installing, and using the Avatalk AI App, you
                  agree to the terms outlined in this Privacy Policy. If you do
                  not agree with these terms, please refrain from using the App.
                </p>

                <h2>1. Information We Collect</h2>
                <h3>1.1 User-Provided Information</h3>
                <p>
                  To operate the Avatalk AI App, we may request certain
                  permissions and collect the following information:
                </p>
                <ul>
                  <li>
                    <strong>Prompt or Image:</strong> The App uses a public API
                    to create avatars based on the prompts or images provided by
                    users.
                  </li>
                </ul>

                <h3>1.2 Automatically Collected Information</h3>
                <ul>
                  <li>
                    <strong>Usage Information:</strong> We collect information
                    about your usage of the App, such as the features you use,
                    the duration of usage, and interactions with the avatars
                    created.
                  </li>
                  <li>
                    <strong>Device Information:</strong> We may collect
                    information about the device you use to access the App,
                    including device type, operating system, and unique device
                    identifiers.
                  </li>
                </ul>

                <h2>2. How We Use Your Information</h2>
                <p>We use the information collected to:</p>
                <ul>
                  <li>
                    <strong>Create Avatars:</strong> The primary purpose of
                    collecting prompts or images is to generate avatars using
                    the public API integrated into the App.
                  </li>
                  <li>
                    <strong>Improve User Experience:</strong> Analyze usage
                    patterns to enhance and optimize the App's features and
                    performance.
                  </li>
                  <li>
                    <strong>Provide Customer Support:</strong> Address user
                    inquiries, troubleshoot problems, and provide assistance.
                  </li>
                </ul>

                <h2>3. Sharing of Information</h2>
                <p>
                  We do not sell, trade, or otherwise transfer your personal
                  information to third parties. However, we may share
                  information in the following circumstances:
                </p>
                <ul>
                  <li>
                    <strong>With Your Consent:</strong> We may share information
                    with third parties if you explicitly consent to such
                    sharing.
                  </li>
                  <li>
                    <strong>Compliance with Laws:</strong> We may disclose
                    information to comply with legal obligations or respond to
                    governmental requests.
                  </li>
                </ul>

                <h2>4. Data Security</h2>
                <p>
                  We take reasonable measures to protect your information from
                  unauthorized access, disclosure, alteration, and destruction.
                  However, no method of transmission over the internet or
                  electronic storage is entirely secure, and we cannot guarantee
                  absolute security.
                </p>

                <h2>5. Changes to this Privacy Policy</h2>
                <p>
                  We reserve the right to update this Privacy Policy
                  periodically. Any changes will be posted on this page, and the
                  effective date will be updated accordingly. It is your
                  responsibility to review this Privacy Policy periodically for
                  changes.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Terms & Conditions Modal */}
      <div
        className="modal fade"
        id="termsModal"
        tabIndex="-1"
        aria-labelledby="termsModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="termsModalLabel">
                Terms & Conditions
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="terms-of-use container mt-2">
                <p>
                  <strong>Effective Date: 17 Jan 2024</strong>
                </p>

                <p>
                  Welcome to Avatalk AI! These Terms of Use ("Terms") govern
                  your use of the Avatalk AI mobile application ("App"). By
                  using the App, you agree to abide by these Terms. If you do
                  not agree with any part of these Terms, please refrain from
                  using the App.
                </p>

                <h2>1. Grant of License</h2>
                <p>
                  Subject to your compliance with these Terms, we grant you a
                  limited, non-exclusive, non-transferable, and revocable
                  license to use the App solely for personal, non-commercial
                  purposes. You may not sublicense, assign, or transfer this
                  license.
                </p>

                <h2>2. User Conduct</h2>
                <p>You agree not to:</p>
                <ul>
                  <li>Violate any applicable laws or regulations.</li>
                  <li>
                    Use the App in a manner that could interfere with, disrupt,
                    negatively affect, or inhibit other users from fully
                    enjoying the App.
                  </li>
                  <li>
                    Use the App for any purpose other than its intended purpose
                    of creating avatars using prompts or images.
                  </li>
                </ul>

                <h2>3. Privacy</h2>
                <p>
                  Your use of the App is also governed by our
                  <a href="/privacy"> Privacy Policy </a>, which can be found
                  here.
                </p>

                <h2>4. Intellectual Property</h2>
                <p>
                  The App and its content, including but not limited to text,
                  graphics, logos, images, and software, are the property of
                  Avatalk AI or its licensors and are protected by intellectual
                  property laws. You may not modify, reproduce, distribute, or
                  create derivative works based on the App or its content.
                </p>

                <h2>5. Disclaimer of Warranties</h2>
                <p>
                  The App is provided "as is" and "as available" without any
                  warranties, express or implied. We do not warrant that the App
                  will meet your requirements, be error-free, or operate without
                  interruption.
                </p>

                <h2>6. Limitation of Liability</h2>
                <p>
                  To the fullest extent permitted by applicable law, Avatalk AI
                  and its affiliates, officers, employees, agents, and licensors
                  shall not be liable for any indirect, incidental, special,
                  consequential, or punitive damages, or any loss of profits or
                  revenues.
                </p>

                <h2>7. Termination</h2>
                <p>
                  We reserve the right to terminate or suspend your access to
                  the App at our discretion, without notice, for any reason,
                  including, but not limited to, a breach of these Terms.
                </p>

                <h2>8. Changes to Terms</h2>
                <p>
                  We reserve the right to update or modify these Terms at any
                  time. Changes will be effective immediately upon posting. Your
                  continued use of the App after changes are posted constitutes
                  your acceptance of the updated Terms.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {ResetModal ? (
        <div className="resetModal loginForm">
          <div className="resetModalContent">
            <h3 className="fs-1">{t('resetPassword.title')}</h3>
            <p className="mt-2 fs-3 text-dark">
              {t('resetPassword.message')}
            </p>
            <input
              className="resetinput mt-2"
              placeholder={t('resetPassword.phonePlaceholder')}
              onChange={(e) => setResetPhone(e.target.value)}
            />
            <p className="mt-2 fs-5 text-dark">{ResetMessage}</p>

            <div className="d-flex flex-row justify-content-end align-items-center mt-4">
              <button
                style={{
                  background: "white",
                  border: "1px solid white",
                  color: "#3859C5",
                }}
                onClick={() => CloseResetModal()}
              >
                {t('common.cancel')}
              </button>

              <button onClick={() => resetpass(ResetPhone)}>
                {ResetLoader ? (
                  <div
                    style={{ width: "20px", height: "20px", padding: "4px" }}
                    className="loader"
                  ></div>
                ) : (
                  t('common.submit')
                )}
              </button>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
}

export default LandingPage;
